import React from "react";
import { getGender } from "../../../../graphql/queries";
import PropTypes from "prop-types";
import * as DataTypes from "../../../../constants/Data/DataTypes";
import GeneralInfo from "../../../Common/GeneralInfo";

const GenderGeneralInfo = (props) => {
  return (
    <GeneralInfo
      modelId={props.genderId}
      modelName={"Degree"}
      listOfProperties={[
        {
          key: 1,
          attributeName: "name",
          attributeTitle: "Name",
          description: "Gender Name",
          dataType: DataTypes.String,
        },
        {
          key: 2,
          attributeName: "order",
          attributeTitle: "Order",
          description: "Gender Appearance Order",
          dataType: DataTypes.String,
        },
        {
          key: 3,
          attributeName: "createdAt",
          attributeTitle: "Created At",
          description: "Gender Created At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 4,
          attributeName: "updatedAt",
          attributeTitle: "Updated At",
          description: "Gender Updated At",
          dataType: DataTypes.DateTime,
        },
      ]}
      queryFunction={getGender}
      queryFunctionName={"getGender"}
    />
  );
};

GenderGeneralInfo.propTypes = {
  genderId: PropTypes.string.isRequired,
};

export default GenderGeneralInfo;
